import { useEffect, useState } from "react";
import { chipApi } from "../api/gameApi";

export default function useChips() {
  const [chips, setChips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const res = await chipApi();
        const body = res?.data;
        const list = Array.isArray(body) ? body : body?.data || [];

        const mapped = list
          .filter((c) => c.isActive !== false)
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .map((c) => ({ v: c.value, c: `c${c.value}` })); // c1, c10, c100, c500 (css class)

        if (alive) setChips(mapped);
      } catch (err) {
        console.error("chip api failed", err);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  return { chips, loading };
}
